<template>
   <div class="crud-wrapper">
      <crud-toolbar :modal-mode="modalMode" :new-state="newState" :title="modalTitle"
                    @onCommand="toolbarCommand"></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

         <v-layout row wrap>
            <v-flex :xs12="!campaignData.data_requested_at" :xs8="campaignData.data_requested_at">
               <label class="v-label v-label--active theme--light aLabel">Para a Campanha</label>
               <label class="subheading text-truncate text-no-wrap">{{campaignData.name}}</label>
            </v-flex>
            <v-flex xs4 v-if="campaignData.data_requested_at" class="secondary" elevation-4 >
               <label class="aLabel body-2 text-xs-center white--text">{{campaignData.statusName}}</label>
               <label class="v-label v-label--active theme--dark aLabel text-xs-center">
                  desde {{campaignData.data_requested_at | moment('DD/MM/YYYY HH:mm')}}
               </label>
            </v-flex>

            <a-select-field clearable label="Abordagem da Campanha" obj="productType" sm6
                            v-model="formData.typeId"></a-select-field>

            <a-text-field label="Idade entre" mask="##" sm3 v-model="formData.ageRange[0]"></a-text-field>
            <a-text-field label="e" mask="##" sm3 v-model="formData.ageRange[1]"></a-text-field>

            <a-select-field chips clearable display-key="code" label="Região" multiple
                            obj="countryState" v-model="formData.states"></a-select-field>
            <a-select-field chips clearable label="Clientes que já possuem contratos com" multiple
                            obj="bank" v-model="formData.banks"></a-select-field>

            <a-number-field label="Parcela maior que" number-mask="rs" sm4
                            v-model="formData.installmentRange[0]"></a-number-field>
            <a-number-field label="e menor que" number-mask="rs" sm4
                            v-model="formData.installmentRange[1]"></a-number-field>

            <a-text-field label="No. Parcelas Pagas" mask="##" sm4 v-model="formData.paidInstallments"></a-text-field>

         </v-layout>

      </crud-form>

   </div>


</template>

<script>
   import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

   export default CrudFormClass.extend({
      name: 'CampaignDataFilter',

      props: ['campaign'],

      data: function () {
         return {
            title: 'Filtrar Campanha',
            formName: 'campaignDataFilter',

            fab: false,

            formData: {
               campaignId: null,
               typeId: null,
               ageRange: [21, 69],
               states: null,
               banks: null,
               installmentRange: [null, null],
               paidInstallments: null
            }

         };
      },

      created () {
         this.formData.campaignId = this.campaign.id;

         if (this.campaign.data_request) {
            this.assignData(this.campaign.data_request);
         }
      },

      computed: {
         campaignData () {
            return this.campaign ? this.campaign : {};
         }

      },

      methods: {
         saveConfirmation () {
            return new Promise((resolve, reject) => {
               this.$msg.confirm({
                  title: 'Confirma os Filtros?',
                  message: `Os filtros especificados serão aplicados pela equipe Consigmais no prazo de até 72hs e disponibilizados na campanha automaticamente.`,
                  actions: ['Sim', 'Não'],
                  defaultAction: 0
               }).then((action) => (action === 0) ? resolve(true) : reject(false));
            });
         }
      }

   });
</script>

<style scoped>
   .bigNumber {
      font-size: 40px;
      font-weight: 400;
   }

   .biggerNumber {
      font-size: 60px;
      font-weight: 500;
      color: orange;
   }

</style>



// WEBPACK FOOTER //
// src/pages/CampaignDataFilter.vue